import React from 'react';
import { compose, graphql } from 'react-apollo';
import gql from 'graphql-tag';
import USER_QUERY from 'components/MainLayout/graphql/userQuery.gql';

import LiteCart from 'containers/Lite/Loadable';
import Cart from './Loadable';

class CartSwitch extends React.PureComponent {
  render() {
    const { userQuery, ...rest } = this.props;
    const currentUser = userQuery && userQuery.user ? userQuery.user : false;

    if (currentUser) {
      if (currentUser.newCartExperience) return <LiteCart {...this.props} />;

      return <Cart {...rest} />;
    }

    return null;
  }
}

const IS_TOKEN = gql`
  query IsToken {
    isToken
  }
`;

export default compose(
  graphql(IS_TOKEN, {
    options: { fetchPolicy: 'cache-only' },
    props: ({ data: { isToken } }) => ({
      isToken,
    }),
  }),
  graphql(USER_QUERY, {
    name: 'userQuery',
    skip: (ownProps) => !ownProps.isToken,
  })
)(CartSwitch);



// WEBPACK FOOTER //
// ./app/containers/LegacyCartPage/Switch.js